(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('InvoiceInfoCustom', InvoiceInfoCustom);

    InvoiceInfoCustom.$inject = ['$resource'];

    function InvoiceInfoCustom($resource) {


        var getInvoiceByOrderBagId = function (OrderBagId) {

            var resourceUrl = 'api/get-invoice-by-order-bag/' + OrderBagId;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };


        var getInvoiceWithItemsById = function (invoiceInfoId) {

            var resourceUrl = 'api/get-invoice-with-items-by-id/' + invoiceInfoId;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };

        var makeInvoiceEditable = function () {
            var resourceUrl = 'api/make-invoice-editable';
            return $resource(resourceUrl, {}, {}
            );
        };

        var finalizeInvoiceInfo = function () {
            var resourceUrl = 'api/finalize-invoice-info';
            return $resource(resourceUrl, {}, {}
            );
        };


        var sendInvoiceInfoToCustomer = function () {
            var resourceUrl = 'api/send-invoice-info-to-customer';
            return $resource(resourceUrl, {}, {}
            );
        };

        var getInvoiceByCustomerId = function (customerId) {

            var resourceUrl = 'api/get-invoice-infos-by-customer-id/' + customerId;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };

        var searchInvoiceInfoByQueryPage = function () {
            var resourceUrl = 'api/search-invoice-info-page';
            return $resource(resourceUrl, {}, {
                    'save': {method: 'POST', isArray: true}
                }
            );
        };

        return {
            getInvoiceByOrderBagId: getInvoiceByOrderBagId,
            getInvoiceWithItemsById: getInvoiceWithItemsById,
            makeInvoiceEditable: makeInvoiceEditable,
            finalizeInvoiceInfo: finalizeInvoiceInfo,
            sendInvoiceInfoToCustomer: sendInvoiceInfoToCustomer,
            getInvoiceByCustomerId: getInvoiceByCustomerId,
            searchInvoiceInfoByQueryPage: searchInvoiceInfoByQueryPage


        };
    }
})();
